import Swal from 'sweetalert2';
import { API_BASE_URL } from '../config';

/**
 * [Kullanıcı Sıfırlama] 3 seçenekli modal (Envanter+ekonomik / Her şeyi sil / Vazgeç) + 2. onay → /api/profile/reset.
 * ProfilePage butonu + dashboard inaktiflik akışı ORTAK kullanır.
 * @param {{inactivity?: boolean}} opts  inactivity=true → "sizi özledik" girişiyle açar.
 */
export async function promptKitchenReset({ inactivity = false } = {}) {
  const intro = inactivity
    ? `<p>Şefim sizi bir süredir aramızda göremiyoruz. Güncel mutfağınızı tam olarak sistemde modelleyemediyseniz
       sizi ilk günkü kayda döndürebiliriz.</p>`
    : '';
  const html = `<div style="text-align:left;font-size:14px;line-height:1.5">
      ${intro}
      <p style="margin-top:${inactivity ? '10px' : '0'}"><b>🧹 Envanter & Ekonomik Sil:</b> Tüm envanter, alışveriş, fiyat, rapor ve plan verisi silinir.
      Anket, profil, alerjen, bebek ve sağlık bilgilerin <b>korunur</b>.</p>
      <p style="margin-top:8px"><b>🔥 Her Şeyi Sil:</b> Hesabın ilk gün kaydına döner — profil ve anket dahil her şey sıfırlanır.
      Premium ve giriş bilgilerin korunur. <b style="color:#dc2626">Geri alınamaz.</b></p>
    </div>`;

  const choice = await Swal.fire({
    title: inactivity ? 'Sizi özledik şefim 👨‍🍳' : 'Mutfağımı Sıfırla',
    html,
    showDenyButton: true,
    showCancelButton: true,
    confirmButtonText: '🧹 Envanter & Ekonomik Sil',
    denyButtonText: '🔥 Her Şeyi Sil',
    cancelButtonText: inactivity ? 'Hiç işlem yapma' : 'Vazgeç',
    confirmButtonColor: '#d97706',
    denyButtonColor: '#dc2626',
    reverseButtons: true
  });

  let mode = null;
  if (choice.isConfirmed) mode = 'partial';
  else if (choice.isDenied) mode = 'full';
  else return false;

  const confirm2 = await Swal.fire({
    title: mode === 'full' ? 'Her şey silinecek — emin misin?' : 'Envanter & ekonomik silinecek — emin misin?',
    text: 'Bu işlem geri alınamaz.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Evet, sıfırla',
    cancelButtonText: 'Vazgeç',
    confirmButtonColor: '#dc2626',
    allowOutsideClick: false
  });
  if (!confirm2.isConfirmed) return false;

  try {
    Swal.fire({ title: 'Sıfırlanıyor…', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
    const token = localStorage.getItem('authToken');
    const res = await fetch(`${API_BASE_URL}/api/profile/reset`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ mode })
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.error || 'reset_failed');
    await Swal.fire({
      title: 'Sıfırlandı ✅',
      text: mode === 'full' ? 'Hesabın ilk gün kaydına döndü.' : 'Envanter ve ekonomik veriler silindi.',
      icon: 'success', confirmButtonText: 'Tamam', allowOutsideClick: false
    });
    if (mode === 'full') window.location.href = '/'; else window.location.reload();
    return true;
  } catch (e) {
    Swal.fire('Hata', 'Sıfırlama başarısız oldu.', 'error');
    return false;
  }
}
